{
  "create": "Crear plantilla",
  "createTemplate": "Crear plantilla de activos",
  "templateName": "Nombre de la plantilla",
  "modelFamily": "Familia modelo",
  "description": "Descripción",
  "dateModified": "Fecha de modificación",
  "status": "Estado",
  "filters": {
    "state": "Estado"
  },
  "states": {
    "active": "Activo",
    "draft": "Borrador",
    "archived": "Archivado",
    "any": "Cualquiera"
  },
  "actions": {
    "edit": "Editar plantilla",
    "activate": "Activar plantilla",
    "moveToDraft": "Mover a Borradores",
    "moveToArchive": "Mover a Archivados"
  },
  "detailsModal": {
    "title": "Detalles de la plantilla",
    "assetClasses": "Clases de activos",
    "close": "Cerrar"
  },
  "error": {
    "transition": "Error al actualizar el estado de la plantilla",
    "update": "Error al actualizar la plantilla"
  },
  "success": {
    "transition": "Estado de la plantilla actualizado correctamente",
    "update": "Plantilla actualizada correctamente"
  }
}
